import { z } from 'zod';

export const countrySchema = z.object({
  code: z.string().length(2),
  name: z.string(),
  flagEmoji: z.string(),
});

export const countryListSchema = z.array(countrySchema);

export type Country = z.infer<typeof countrySchema>;
